import { type OpenApiSchemaProduct, type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { getProductQuery } from '../api';

export type VariantsByProductId<IDs extends OpenApiSchemaProduct['id'] = OpenApiSchemaProduct['id']> = Partial<
    Record<IDs, OpenApiSchemaProductVariant[]>
>;

export const getAllVariantsByProductIds = <ID extends OpenApiSchemaProduct['id']>(
    productIds: ID[]
): Promise<{ list: OpenApiSchemaProductVariant[]; byProductId: VariantsByProductId<ID> }> => {
    const idIsProductIds = (id: string): id is ID => productIds.includes(id as ID);

    return Promise.all(productIds.map((id) => getProductQuery({ productId: id }))).then((results) =>
        results.reduce<{ list: OpenApiSchemaProductVariant[]; byProductId: VariantsByProductId<ID> }>(
            (acc, { id, variants }) => {
                if (idIsProductIds(id)) {
                    acc.byProductId[id] = variants;
                    acc.list.push(...variants);
                }

                return acc;
            },
            { list: [], byProductId: {} }
        )
    );
};
